import React, { RefObject } from 'react'
import { Box, Flex, Text, Label } from '@workwhile/ui'
import { UserOutstandingBalance } from 'api/payments'
import { AmountEntry } from './AmountEntry'

interface BBSIBoxProps {
  outstandingBalance: UserOutstandingBalance
  bbsiBoxRef: RefObject<HTMLDivElement | null>
}

export const BBSIBox = ({ outstandingBalance, bbsiBoxRef }: BBSIBoxProps) => {
  if (outstandingBalance?.completedBbsiPayouts === 0) return null

  return (
    <Box
      ref={bbsiBoxRef}
      position="relative"
      bg="white"
      border="1px solid"
      borderColor="border"
      borderRadius="medium"
      p={3}
      minWidth="250px"
      maxWidth="100%"
      width="100%"
      boxShadow="small"
      zIndex={2}
    >
      <Flex justifyContent="space-between" alignItems="center" mb={3}>
        <Flex alignItems="center" gap={2}>
          <Text fontWeight="bold" color="primary" fontSize={3}>
            BBSI
          </Text>
          <Label variant="primary">W2</Label>
          <Label variant="neutral">Deprecated</Label>
        </Flex>
      </Flex>
      <Flex flexDirection="row" gap={3}>
        {/* Content Box */}
        <Box
          bg="background"
          border="1px solid"
          borderColor="border"
          borderRadius="small"
          p={3}
          flex={1}
        >
          <Text color="lightText" mb={2}>
            BBSI was the previous W2 payroll provider
          </Text>
          <AmountEntry
            label="Processed Payroll:"
            value={outstandingBalance.completedBbsiPayouts}
          />
        </Box>
      </Flex>
    </Box>
  )
}
